const Measure = {
  code: true,
  precision: true,
  name: true,
  abbr: true
};

export { Measure };